import React, { useState } from "react";
import {
  Drawer,
  Form,
  Button,
  Input,
  Switch,
  message,
  InputNumber,
  DatePicker,
} from "antd";
import { Container, Row, Col } from "react-bootstrap";
import { API, Headers } from "../../Config";
import axios from "axios";
var width = window.innerWidth;
var innerwidth = window.innerWidth <= 760;
function FormModal(props) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    let obj = {
      transaction_id: values.transaction_id,
      pickup_collections_id: parseInt(values.pickup_collections_id),
      amount: values.amount,
      status: values.status,
      payment_type: values.payment_type,
      collected_datetime: values.collected_datetime,
      collected_by: values.collected_by,
      active: values.active,
    };
    let URL =
      props.mode === "post"
        ? API.TRANSACTIONS_ACTION
        : API.TRANSACTIONS_ACTION + props.item.id;
    axios({
      method: props.mode,
      url: API.BASR_URL + URL,
      headers: Headers(),
      data: obj,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onchange();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  return (
    <Drawer
      placement={props.mode === "post" ? "right" : "left"}
      title={
        <span className="txt4">
          {props.mode === "post" ? "New" : "Update"} Transaction
        </span>
      }
      width={innerwidth ? width : width / 2.7}
      onClose={() => props.onClose()}
      visible={props.visible}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form
        layout="vertical"
        hideRequiredMark
        onFinish={onFinish}
        initialValues={{
          transaction_id: props.item && props.item.transaction_id,
          pickup_collections_id: props.item && props.item.pickup_collections_id,
          amount: props.item && props.item.amount,
          status: props.item && props.item.status,
          payment_type: props.item && props.item.payment_type,
          collected_datetime: props.item && props.item.collected_datetime,
          collected_by: props.item && props.item.collected_by,
          active: props.item && props.item.active ? props.item.active : false,
        }}
      >
        <Container>
          <Row>
            <Col sm="6" xs="12">
              <Form.Item
                name="transaction_id"
                label="Country Name"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Name" />
              </Form.Item>
              <Form.Item
                name="amount"
                label="Amount"
                rules={[{ required: true, message: "required" }]}
              >
                <InputNumber
                  placeholder="Enter Name"
                  style={{ width: "100%" }}
                />
              </Form.Item>
              <Form.Item
                name="payment_type"
                label="Payment Type"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Continent Name" />
              </Form.Item>
              <Form.Item
                name="collected_by"
                label="collected by"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Continent Name" />
              </Form.Item>
              <Form.Item
                label="Active"
                name="active"
                rules={[{ required: true, message: "required" }]}
                valuePropName={props.item.active ? "checked" : "uncheked"}
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col sm="6" xs="12">
              <Form.Item
                name="pickup_collections_id"
                label="Pickup Collections"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Continent Name" />
              </Form.Item>
              <Form.Item
                name="payment_type"
                label="Payment Type"
                rules={[{ required: true, message: "required" }]}
              >
                <Input placeholder="Enter Continent Name" />
              </Form.Item>
              <Form.Item
                name="collected_datetime"
                label="collected date time"
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker
                  placeholder="Pick a date"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {props.mode === "post" ? null : <Col sm="6" xs="12"></Col>}
            <Col sm="6" xs="12">
              <Row>
                <Col sm="6" xs="12">
                  <Button onClick={() => props.onClose()} block>
                    Cancel
                  </Button>
                </Col>
                <Col sm="6" xs="12">
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    block
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Form>
    </Drawer>
  );
}
export default FormModal;
